import { useAuth } from "react-oidc-context";
import * as React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { SaveCurrentPath } from "../Core";
import { useWebPortalLegacyClient } from "../misc/api/WebPortalTokenClient";

export const SignIn = () => {
    const { user, signinRedirect } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const client = useWebPortalLegacyClient();

    React.useEffect(() => {
        if (!user) {
            SaveCurrentPath(location);
            signinRedirect();
        }
    }, []);

    return null;
}
